import createEditSpeedOverride from 'Modules/realtimeMaps/main/components/speedOverride/components/speedOverrideCreateEdit/lan/en';
import listSpeedOverride from 'Modules/realtimeMaps/main/components/speedOverride/components/speedOverrideList/lan/en';
import deleteSpeedOverride from 'Modules/realtimeMaps/main/components/speedOverride/components/speedOverrideDelete/lan/en';

export default {
    ...createEditSpeedOverride,
    ...listSpeedOverride,
    ...deleteSpeedOverride
};